import MoneyConnectHeader from "containers/App/MoneyConnectHeader/MoneyConnectHeader1";
import { HeaderHeight } from "const";
import classNames from "classnames";

const InformContainer = ({ className, useMncHeader, children }) => {
  return (
    <>
      {useMncHeader && <MoneyConnectHeader height={HeaderHeight} />}
      <div className="inform-page">
        <div className="container">
          <div className={classNames("card-glassmorphism py-5", className)}>{children}</div>
        </div>
      </div>
    </>
  );
};

export default InformContainer;

InformContainer.defaultProps = {
  useMncHeader: true,
};
